<template>
    <v-dialog v-model="editorShownProceeding" width="850" persistent>
        <!-- Begin:v-card:Mode:update -------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid green;">
            <!-- >>> Card Title -------------------------------------------- -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-car"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>
            <!-- <<< Card Title -------------------------------------------- -->


            <!-- >>> Selected Proceeding List ------------------------------ -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: green; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/Proceeding:</strong></div>
            <selected-proceedings-list v-model="employees" v-if="editorShownProceeding" />
            <!-- <<< Selected Proceeding List ------------------------------ -->


            <v-divider style="margin-top: 20px;"></v-divider>


            <!-- >>> Build Proceeding -------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: green; padding-right: 10px;" class="b-fa b-fa-car"></i><strong>Build your Proceeding:</strong></div>
            <v-card-text class="pa-5" style="position: relative;">
                <!-- >>> Proceeding Info -->
                <comment-textarea v-model="info" label="Proceeding Info:" maxlength="300" />
                <!-- <<< Proceeding Info -->

                <!-- >>> proceedingFrom,proceedingTo -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <input-field v-model="proceedingFrom" label="Proceeding from Place:" />
                    </v-col>

                    <v-col cols="6" class="smallerHeight">
                        <input-field v-model="proceedingTo" label="Proceeding to Place:" />
                    </v-col>
                </v-row>
                <!-- >>> proceedingFrom,proceedingTo -->

                <!-- >>> codeAptFrom,codeAptTo -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <airports-combo v-model="codeAptFrom" label="Select Proceeding From Arprt:" />
                    </v-col>
                    <v-col cols="6" class="smallerHeight">
                        <airports-combo v-model="codeAptTo" label="Select Proceeding To Arprt:" />
                    </v-col>
                </v-row>
                <!-- <<< codeAptFrom,codeAptTo -->

                <!-- >>> proType,toFlight -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <proceeding-types-combo v-model="proType" label="Select - Proceeding Type:" />
                    </v-col>

                    <v-col cols="6" class="smallerHeight">
                        <yesno-combo v-model="toFlight" label="Select - Flight to:" />
                    </v-col>
                </v-row>
                <!-- <<< proType,toFlight -->

                <!-- >>> Date Times -->
                <datetime v-model="startDate" label="Proceeding - start" disabled="false" disabledTime="false" ref="startTimer" style="padding-top: 25px !important;" />
                <datetime v-model="endDate" label="Proceeding - end" disabled="false" disabledTime="false" ref="endTimer" />
                <!-- <<< Date Times -->

                <!-- Make visile Button -->
                <!-- <v-btn absolute dark fab top right color="#ab3b7a"><v-icon>mdi-eye</v-icon></v-btn> -->
            </v-card-text>
            <!-- <<< Build Proceeding -------------------------------------- -->


            <v-divider></v-divider>


            <!-- >>> Card Actions ------------------------------------------ -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('PROCEEDING').length }} Proceeding(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_ProceedingDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_Update_Proceeding"> Save</v-btn>
            </v-card-actions>
            <!-- <<< Card Actions ------------------------------------------ -->
        </v-card>
        <!-- End:v-card:Mode:update ---------------------------------------- -->



        <!-- Begin:v-card:Mode:create -------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid green;">
            <!-- >>> Card Title -------------------------------------------- -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-car"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>
            <!-- <<< Card Title -------------------------------------------- -->


            <!-- >>> Selected Employees List ------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: green; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownProceeding" />
            <!-- <<< Selected Employees List ------------------------------- -->


            <v-divider style="margin-top: 0px;"></v-divider>


            <!-- >>> Build Proceeding -------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: green; padding-right: 10px;" class="b-fa b-fa-car"></i><strong>Build your Proceeding:</strong></div>
            <v-card-text class="pa-5" style="position: relative;">
                <!-- >>> Proceeding Info -->
                <comment-textarea v-model="info" label="Proceeding Info:" maxlength="300" />
                <!-- <<< Proceeding Info -->

                <!-- >>> proceedingFrom,proceedingTo -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <input-field v-model="proceedingFrom" label="Proceeding from Place:" />
                    </v-col>

                    <v-col cols="6" class="smallerHeight">
                        <input-field v-model="proceedingTo" label="Proceeding to Place:" />
                    </v-col>
                </v-row>
                <!-- >>> proceedingFrom,proceedingTo -->

                <!-- >>> codeAptFrom,codeAptTo -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <airports-combo v-model="codeAptFrom" label="Select From Arprt:" />
                    </v-col>
                    <v-col cols="6" class="smallerHeight">
                        <airports-combo v-model="codeAptTo" label="Select To Arprt:" />
                    </v-col>
                </v-row>
                <!-- <<< codeAptFrom,codeAptTo -->

                <!-- >>> proType,toFlight -->
                <v-row>
                    <v-col cols="6" class="smallerHeight">
                        <proceeding-types-combo v-model="proType" label="Select - Proceeding Type:" />
                    </v-col>

                    <v-col cols="6" class="smallerHeight">
                        <yesno-combo v-model="toFlight" label="Select - Flight to:" />
                    </v-col>
                </v-row>
                <!-- <<< proType,toFlight -->

                <!-- >>> Date Times -->
                <datetime v-model="startDate" label="Proceeding - start" disabled="false" disabledTime="false" ref="startTimer" style="padding-top: 25px !important;" />
                <datetime v-model="endDate" label="Proceeding - end" disabled="false" disabledTime="false" ref="endTimer" />
                <!-- <<< Date Times -->



                <!-- Make visile Button -->
                <!-- <v-btn absolute dark fab top right color="#ab3b7a"><v-icon>mdi-eye</v-icon></v-btn> -->
            </v-card-text>
            <!-- <<< Build Proceeding -------------------------------------- -->


            <v-divider></v-divider>


            <!-- >>> Card Actions ------------------------------------------ -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_ProceedingDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_Create_Proceeding"> Save</v-btn>
            </v-card-actions>
            <!-- <<< Card Actions ------------------------------------------ -->
        </v-card>
        <!-- End:v-card:Mode:create ---------------------------------------- -->




        <!-- Begin:Content:Dialog ------------------------------------------ -->
        <v-dialog v-model="dialog" max-width="400">
            <v-card>
                <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px;"><i style="color: #e53f2c;" class="b-fa b-fa-exclamation-triangle"></i>&nbsp;&nbsp;'From Arprt/To Arprt' - Error</v-card-title>

                <v-card-text class="pa-5">
                    Proceeding does certainly not go from or to an Airport?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="dialog = false; agree = false;">Disagree</v-btn>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="dialog = false; agree = true;">Agree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import AirportsCombo from '../../AirportsCombo.vue';
    import Datetime from '../../DateTime.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import ProceedingTypesCombo from '../../ProceedingTypesCombo.vue';
    import InputField from '../../InputField.vue';
    import YesnoCombo from '../../YesnoCombo.vue';
    import SelectedProceedingsList from '../../SelectedProceedingsList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-proceeding',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownProceeding
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            AirportsCombo,
            Datetime,
            CommentTextarea,
            ProceedingTypesCombo,
            YesnoCombo,
            InputField,
            SelectedProceedingsList,
            SelectedEmployeesList,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            idAptFrom       : null, // gets set in: 'get_AirportId'
            codeAptFrom     : null,
            idAptTo         : null, // gets set in: 'get_AirportId'
            codeAptTo       : null,
            info            : null,
            toFlight        : null,
            proType         : null,
            proceedingFrom  : null,
            proceedingTo    : null,
            employees       : [],
            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            dialog          : false, // Dialog: 'Proceeding does certainly not go from or to an Airport?'
            agree           : false,

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            agree(value) {

                if (value === true) {
                    // >>> ------------------ update
                    if (this.editorMode === 'update') {
                        this.onSave_Update_Proceeding();
                    }

                    // >>> ------------------ create
                    if (this.editorMode === 'create') {
                        this.onSave_Create_Proceeding();
                    }
                }

            }, // eo agree()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_Airports',
                'get_selectedMultiEvents', // get: selected Events
                'get_selectedMultiResources', // get: selected Resources
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownProceeding()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownProceeding: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/proceeding/EventEditor.vue >>> editorShownProceeding get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    idAptFrom       : eventRecord.proObject.idAptFrom,
                                    codeAptFrom     : eventRecord.proObject.codeAptFrom,
                                    idAptTo         : eventRecord.proObject.idAptTo,
                                    codeAptTo       : eventRecord.proObject.codeAptTo,
                                    info            : eventRecord.proObject.info,
                                    toFlight        : eventRecord.proObject.toFlight,
                                    proType         : eventRecord.proObject.typeOfProceeding, // Attention:
                                    proceedingFrom  : eventRecord.proObject.proceedingFrom,
                                    proceedingTo    : eventRecord.proObject.proceedingTo,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    idAptFrom       : null,
                                    codeAptFrom     : null,
                                    idAptTo         : null,
                                    codeAptTo       : null,
                                    info            : null,
                                    toFlight        : false,
                                    proType         : 'TRAIN',
                                    proceedingFrom  : null,
                                    proceedingTo    : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo function editorShownProceeding get()


                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/proceeding/EventEditor.vue >>> editorShownProceeding set');
                    this.$emit('input', value);

                } // eo function editorShownProceeding set()

            } // eo editorShownProceeding

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_create_Multiple_Proceedings', // Call: Create Multiple Proceedings,
                'actn_update_Multiple_Proceedings', // Call: Update Multiple Proceedings,
                'actn_set_SelectedMultiEvents',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_Update_Proceeding()
            *
            * Desc: 'Update Proceeding' - Call.
            * Note: Agree in Dialog calls this Function again.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_Update_Proceeding: function(){

                let me = this,
                    singleParamObject = {},
                    params = {
                        proceedings : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/proceedings/EventEditor.vue >>> onSave_Update_Proceeding');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id              : employee.originalId,
                        idResource      : null,
                        idResources     : [employee.resourceId],
                        info            : me.info,
                        proceedingStart : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        proceedingEnd   : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        proceedingFrom  : me.proceedingFrom,
                        proceedingTo    : me.proceedingTo,
                        toFlight        : me.toFlight,
                        type            : me.proType,
                        idAptFrom       : me.get_AirportId(me.codeAptFrom),
                        idAptTo         : me.get_AirportId(me.codeAptTo),
                        codeAptFrom     : me.codeAptFrom,
                        codeAptTo       : me.codeAptTo,
                        status          : 'PENDING'
                    };
                    params.proceedings.push(singleParamObject);
                });

                if (this.validateParams_Update(params) === true) {
                    this.actn_update_Multiple_Proceedings(params);
                }

            }, // eo function onSave_Update_Proceeding()


            /*******************************************************************
            * onSave_Create_Proceeding()
            *
            * Desc: 'Create Proceeding' - Call.
            * Note: Agree in Dialog calls this Function again.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_Create_Proceeding: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/proceedings/EventEditor.vue >>> onSave_Create_Proceeding');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    idResource      : null,
                    idResources     : this.employees,
                    info            : me.info,
                    proceedingStart : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    proceedingEnd   : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    proceedingFrom  : me.proceedingFrom,
                    proceedingTo    : me.proceedingTo,
                    toFlight        : me.toFlight,
                    type            : me.proType,
                    idAptFrom       : me.get_AirportId(me.codeAptFrom),
                    idAptTo         : me.get_AirportId(me.codeAptTo),
                    status          : 'PENDING'
                };

                if (this.validateParams_Create(params) === true) {
                    this.actn_create_Multiple_Proceedings(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                }

            }, // eo function onSave_Create_Proceeding()


            /*******************************************************************
            * onClose_ProceedingDialog()
            *
            * Desc: Close Proceeding Dialog.
            * Note:
            *
            */
            onClose_ProceedingDialog: function(){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/proceedings/EventEditor.vue >>> onClose_ProceedingDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array
                me.editorShownProceeding = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_ProceedingDialog()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams_Update()
            *
            * Desc: Validate Params before Update.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams_Update: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/proceedings/EventEditor.vue >>> validateParams_Update');
                // >>> -------------------------- 'resources?'                   // Check 1
                if (params.proceedings.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Ressources is a required field.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                // >>> -------------------------- 'startDate bef endDate?'      // Check 2
                if (valid === true) {  // still valid
                    startDate = moment(params.proceedings[0].checkinDate);
                    endDate = moment(params.proceedings[0].checkoutDate);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'toFlight?'                   // Check 3
                if (valid === true) {  // still valid
                    if (params.proceedings[0].toFlight === null || params.proceedings[0].toFlight === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Flight to' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'proType?'                    // Check 4
                if (valid === true) {  // still valid
                    if (params.proceedings[0].type === null || params.proceedings[0].type === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Proceeding Type' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------



                // >>> -------------------------- 'Proceeding does ... '        // Check 5
                if (valid === true) {  // still valid
                    if ((params.proceedings[0].idAptFrom === null || params.proceedings[0].idAptFrom === undefined) && (params.proceedings[0].idAptTo === null || params.proceedings[0].idAptTo === undefined)) {
                        if (this.agree === false) {
                            this.dialog = true;
                            valid = false;
                        }  else {
                            this.agree = false;
                            this.dialog = false;
                            valid = true;
                        }
                    }
                }


                return valid;

            }, // eo function validateParams_Update()


            /*******************************************************************
            * validateParams_Create()
            *
            * Desc: Validate Params before Create.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams_Create: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/proceedings/EventEditor.vue >>> validateParams_Create');
                // >>> -------------------------- 'resources?'                   // Check 1
                if (params.idResources === null || params.idResources === undefined || params.idResources.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Ressources is a required field.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                // >>> -------------------------- 'startDate bef endDate?'      // Check 2
                if (valid === true) {  // still valid
                    startDate = moment(params.checkinDate);
                    endDate = moment(params.checkoutDate);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'toFlight?'                   // Check 3
                if (valid === true) {  // still valid
                    if (params.toFlight === null || params.toFlight === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Flight to' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'proType?'                    // Check 4
                if (valid === true) {  // still valid
                    if (params.type === null || params.type === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Proceeding Type' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------



                // >>> -------------------------- 'Proceeding does ... '        // Check 5
                if (valid === true) {  // still valid
                    if ((params.idAptFrom === null || params.idAptFrom === undefined) && (params.idAptTo === null || params.idAptTo === undefined)) {
                        if (this.agree === false) {
                            this.dialog = true;
                            valid = false;
                        }  else {
                            this.agree = false;
                            this.dialog = false;
                            valid = true;
                        }
                    }
                }


                return valid;

            }, // eo function validateParams_Create()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_AirportId()
            *
            * Desc: Return Airports ID.
            * Note:
            *
            */
            get_AirportId: function(code) {

                let me = this,
                    aptId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/proceedings/EventEditor.vue >>> validateParams_Create');
                this.get_Airports.forEach((apt, i) => {
                    if (apt.aptCode === code) {
                        // this.idApt = apt.idAirport;
                        aptId = apt.idAirport;
                    }
                });


                return aptId;

            }, // eo function get_AirportId()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .smallerHeight {
        padding-top: 0px;
        padding-bottom: 0px;
    }
</style>

